<div class="flex flex-col media-cards white-bg" (click)="openVideo()">
  <div class="thumbnail-container">
    <img class="thumbnail" [src]="media.iconHref">
    <app-play-button></app-play-button>
  </div>
  <div class="fw-600 fs-24 pl-16 pr-16 pt-24 pb-8 word-break-word">{{ media.name }}</div>
  <div class="pl-16 pr-16 pb-24 word-break-word description fw-400 fs-14">{{ media.description }}</div>
</div>
